<section [attr.data-theme]='theme'>
  <app-loading-spinner class="relative z-[1000]" *ngIf="loading$ | async"></app-loading-spinner>
  <router-outlet></router-outlet>
</section>